import request from '@/utils/request'

// get message list
export const messageList = (params) => {
  return request({
    url: '/api/message/list',
    method: 'get',
    params:params
  })
}
export const send = (param) => {
  return request({
    url: '/api/message/send',
    method: 'post',
    data:param
  })

}
export const readed = (param) => {
  return request({
    url: '/api/message/readed',
    method: 'post',
    data:param
  })
}

export const setRecipientName = (param) => {
  return request({
    url: '/api/user/setRecipientName',
    method: 'post',
    data:param
  })
}


